import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import LoginPage from './pages/Login';
import Dashboard from './pages/Dashboard';
import AppContent from './pages/AppContent';
import HostManagement from './pages/HostManagement';
import Attendees from './pages/Attendees';
import EventManagement from './pages/EventManagement';
import EventDetailPage from './pages/EventDetail';
import ContactUs from './pages/ContactUs';
import UserTransactions from './pages/UserTransactions';
import Subscription from './pages/Subscription';
import Payout from './pages/Payout';
import "animate.css"
import WaitingList from './pages/WaitingList';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />}/>
        <Route path="/dashboard" element={<AppContent><Dashboard /></AppContent>}/>
        <Route path="/host-management" element={<AppContent><HostManagement /></AppContent>}/>
        <Route path="/attendees" element={<AppContent><Attendees/></AppContent>}/>
        <Route path="/event-management" element={<AppContent><EventManagement/></AppContent>}/>
        <Route path="/event-details/:id" element={<AppContent><EventDetailPage/></AppContent>}/>
        <Route path="/contact-us/" element={<AppContent><ContactUs/></AppContent>}/>

        <Route path="/user-transactions" element={<AppContent><UserTransactions/></AppContent>}/>
        <Route path="/subscription" element={<AppContent><Subscription/></AppContent>}/>
        <Route path="/payout" element={<AppContent><Payout/></AppContent>}/>
        <Route path="/waiting-list" element={<AppContent><WaitingList/></AppContent>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
